import { Suspense, useState } from "react"
import { Outlet, useNavigate } from "react-router-dom"
import { useAuth0 } from "@auth0/auth0-react"
import { toast } from "sonner"
import { Sidebar } from "@/components/ui/sidebar"
import { TopNav } from "@/components/ui/top-nav"
import { LogoutModal } from "@/components/ui/logout-modal"
import { env } from "@/lib/env"

export function Layout() {
  const { logout } = useAuth0()
  const navigate = useNavigate()
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false)

  const handleLogoutClick = () => {
    setIsLogoutModalOpen(true)
  }

  const handleLogoutConfirm = () => {
    setIsLogoutModalOpen(false)
    // If using placeholder Auth0 domain, perform local logout only
    if (env.VITE_AUTH0_DOMAIN.includes("your-tenant")) {
      toast.success("Signed out (local)")
      navigate("/sign-in")
      return
    }
    logout({
      logoutParams: {
        returnTo: window.location.origin + "/sign-in",
      },
    })
  }

  const handleLogoutCancel = () => {
    setIsLogoutModalOpen(false)
  }

  const handleProfileClick = () => {
    navigate("/settings")
  }

  return (
    <div className="flex h-screen bg-background">
      <Sidebar
        onLogoutClick={handleLogoutClick}
        onProfileClick={handleProfileClick}
      />

      <div className="flex flex-1 flex-col overflow-hidden">
        <TopNav onLogoutClick={handleLogoutClick} />

        <main className="flex-1 overflow-auto p-6">
          <Suspense fallback={null}>
            <Outlet />
          </Suspense>
        </main>
      </div>

      <LogoutModal
        isOpen={isLogoutModalOpen}
        onConfirm={handleLogoutConfirm}
        onCancel={handleLogoutCancel}
      />
    </div>
  )
}
